import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { FAQS } from '../../data/content';
import { Reveal } from '../ui/Reveal';
import { Icons } from '../ui/Icons';

const easeOut = [0.22, 1, 0.36, 1] as const;

export function Faq() {
  const { openLeadForm } = useApp();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-20 sm:py-28 bg-blush">
      <div className="pointer-events-none absolute inset-0 bg-grain opacity-60" />
      <div className="container-rosa relative">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="eyebrow">Questions families ask</p>
          <h2 className="mt-3 font-display text-4xl font-bold leading-[1.08] tracking-[-0.01em] text-plum sm:text-5xl">
            Answers, in plain language.
          </h2>
        </Reveal>

        <div className="mx-auto mt-12 max-w-3xl">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 0.04}>
                <div className="mb-3 rounded-2xl border border-stone bg-white shadow-soft">
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-display text-lg font-medium text-plum">{item.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 180 : 0 }}
                      transition={{ duration: 0.3, ease: easeOut }}
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-colors ${
                        isOpen ? 'bg-terracotta/12 text-terracotta' : 'bg-stone/60 text-plum/60'
                      }`}
                    >
                      <Icons.chevronDown width={18} height={18} />
                    </motion.span>
                  </button>

                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: easeOut }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-5 font-body text-plum/70">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mx-auto mt-12 max-w-3xl text-center">
          <p className="font-body text-lg leading-relaxed text-plum/70">
            Still unsure? Start with a free in-home assessment. It costs nothing and there is no
            obligation.
          </p>
          <button onClick={() => openLeadForm()} className="btn-primary mt-6">
            Get a free safety assessment <Icons.arrowRight width={18} height={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
